import React from 'react';
import Component from '@vfuk/core-animate';
const Animate = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Animate;
